import React, { Component, useEffect, useState } from 'react';
import { isHebrew } from '../../../App';
import { makeStyles } from '@material-ui/core/styles';

import {
  Box,
  Grid,
  MobileStepper,
  Typography,
  useTheme,
} from '@material-ui/core';
import { BodyText, HeadingText } from './TextHelpers';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import BriefCaseIcon from '../images/briefcase_icon.svg';
import EventsIcon from '../images/events_icon.svg';
import MarketingIcon from '../images/marketing_icon.svg';

import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { useTranslation } from 'react-i18next';
import { lclDirection } from '../../../utils/vlStrings';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const useStyles = makeStyles((theme) => ({
  caseStudyContainer: {
    height: '540px',
    [theme.breakpoints.down('xs')]: {
      height: '950px',
    },
  },
  caseStudyChild: {
    height: '380px',
    [theme.breakpoints.down('xs')]: {
      height: '800px',
      flexDirection: 'column',
    },
    flexDirection: 'row',
  },
  caseStudyChildImageContainer: {
    width: '50%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: '300px',
    },
  },
  caseStudyChildInfoContainer: {
    width: '50%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: '500px',
    },
  },
  mobileStepper: {
    background: 'none',
  },
  mobileStepperDot: {
    background: 'rgba(255, 255, 255, 0.3)',
  },
  mobileStepperDotActive: {
    background: theme.palette.secondary.light,
  },
}));

const case_study_json = [
  {
    imageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634200310/kre8.tv/landing_pages/case_study_tau_vfcpr6.png',
    icon: MarketingIcon,
    header: 'Marketing',
    title: 'Tel Aviv University Graduation',
    detail:
      'The prestigious Tel Aviv University utilized short form videos from a few extravagant creators to help spread the word and attract an audience ahead of their upcoming event. They wanted to do it in a fun and quirky way that better reasonated with their demographics and paired up the creators with custom made filters. The videos were shared online and sent through groups',
    number_titles: ['500+', '100k'],
    number_details: ['Shares', 'Organic views within groups'],
  },
  {
    imageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634200835/kre8.tv/landing_pages/case_study_hanny_n_ds6kz9.png',
    icon: MarketingIcon,
    header: 'Marketing',
    title: 'Tulip Natural Influencer Marketing',
    detail:
      'Tulip Natural ordered a variety of video content from Hani Nachmias who did an excellent job of trying out the products and demonstrating their value to the audience. She did it naturally, from home, which helped convey credibility to prospects and ultimately result in excellent engagement data and an astronomical number of views',
    number_titles: ['1.1m', '2x', '2x'],
    number_details: [
      'Views across campaign',
      'Performance vs other campaigns',
      'Increase in engagement',
    ],
  },
  {
    imageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634200834/kre8.tv/landing_pages/case_study_beach_bums_uz5psz.png',
    icon: MarketingIcon,
    header: 'Marketing',
    title: 'Lord of the Board original content',
    detail:
      'Beach Bum Games, which runs the successful game Lord of the Board, wanted to launch a special campaign that came out of the box and aroused the interest of potential users. Through creative they ordered a variety of content from several creators, including Gera Sandler and Uri Gabriel they created a witty and funny video that manages to arouse great interest among viewers and download their product directly from the ad they stopped to watch.',
    number_titles: ['7x', '92%', '100s'],
    number_details: [
      'Engagement vs. campaign average',
      'Positive sentiment, nearly 2x brand benchmark',
      'Of personalized videos delivered',
    ],
  },
];

const case_study_json_hebrew = [
  {
    imageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634200310/kre8.tv/landing_pages/case_study_tau_vfcpr6.png',
    icon: MarketingIcon,
    header: 'שיווק',
    title: 'אוניברסיטת תל אביב - טקס סיום לימודים',
    detail:
      'אוניברסיטת תל אביב היוקרתית השתמשה בסרטוני טופס קצרים של כמה יוצרים בזבזניים בכדי לעזור להפיץ את הבשורה ולמשוך קהל לקראת האירוע הקרוב. הם רצו לעשות את זה בצורה מהנה ומשונה, שתנמק טוב יותר את הדמוגרפיה שלהם וזיוו את היוצרים עם פילטרים בהתאמה אישית. הסרטונים שותפו באינטרנט ונשלחו דרך קבוצות',
    number_titles: ['500+', '100k'],
    number_details: ['שיתופים', 'צפיות אוגרניות'],
  },
  {
    imageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634200835/kre8.tv/landing_pages/case_study_hanny_n_ds6kz9.png',
    icon: MarketingIcon,
    header: 'שיווק',
    title: 'קמפיין של טוליף נטורל ',
    detail:
      'טוליפ נטורל הזמינו שלל תכני וידאו מחני נחמיאס שעשתה עבודה מעולה בלנסות את המוצרים ולהדגים את הערך שלהם לקהל. היא עשתה זאת בצורה טבעית, מביתה, מה שעזר לשדר אמינות ללקוחות פונטציאלים ולבסוף לגרום לנתוני מעורבות מצוינים ומספר צפיות אסטרונומי',
    number_titles: ['1.1m', '2x', '2x'],
    number_details: [
      'צפיות בתכני הקמפיין',
      'ביצועים לעומת קמפיינים אחרים',
      'העלאה במוערבות',
    ],
  },
  {
    imageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634200834/kre8.tv/landing_pages/case_study_beach_bums_uz5psz.png',
    icon: MarketingIcon,
    header: 'שיווק',
    title: 'תוכן מקורי בשילוב יוצרי תוכן של לורד אוף דה בורד',
    detail:
      'ביצ׳ באם משחקים המפעילה את המשחק המצליח ״לורד אוף דה בורד״ רצו לצאת בקמפיין מיוחד שיוצא מהקופסא ומעורר עניין אצל משתמשים פונטנציאלים. דרך קריאייט הם הזמינו שלל תכנים מכמה יוצרים, ביניהם גרא סנדלר ואורי גבריאל ולבסוף יצרו סרטון שנון ומצחיק שמצליח לעורר עניין רב אצל הגולשים ולבסוף גם להוריד את המוצר שלהם ישירות מהמודעה שעצרו לצפות.',
    number_titles: ['2.5x', '95%', '1000+'],
    number_details: [
      'מעורבות לעומת קמפיינים קודמים',
      'תגובות חיוביות',
      'הורדות לאפליקציה',
    ],
  },
];

/**
 * Component showing info ,detail, and numbers
 * @param {*} props
 * @returns
 */
const CaseStudyStatsBox = (props) => {
  const { header, title, detail, numberTitles, numberDetails, icon } = props;
  return (
    <Box
      dir={lclDirection()}
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="space-between"
    >
      <Box id="cs-sb-icon-and-header">
        <Typography variant="h5">
          <Box fontWeight={700} color="white" fontSize="18px">
            <Box display="flex" flexDirection="row" alignItems="center">
              {icon}
              <Box ml={1.5} mr={1.5}>
                {header}
              </Box>
            </Box>
          </Box>
        </Typography>
      </Box>
      <Box id="cs-sb-title" mt={4}>
        <HeadingText fontWeight={600} fontSize="24px">
          {title}
        </HeadingText>
      </Box>
      <Box id="cs-sb-detail" mt={3}>
        <BodyText fontSize="16px"> {detail}</BodyText>
      </Box>
      <Box
        id="cs-sb-numbers-boxes"
        display="flex"
        flexDirection="row"
        alignItems="flex-start"
        mt={3}
      >
        {numberTitles.map((item, index) => {
          return (
            <Box id="cs-sb-number-container" width="33%" p={1}>
              <Box id="number-title">
                <HeadingText fontSize="20px" color="secondary.main">
                  {numberTitles[index]}
                </HeadingText>
              </Box>
              <Box id="number-detail" mt={2}>
                <BodyText fontSize="16px">{numberDetails[index]}</BodyText>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

/**
 * Main component for each case study
 * @param {*} props
 * @returns
 */
const CaseStudy = (props) => {
  const {
    imageURL,
    icon,
    header,
    title,
    detail,
    numberTitles,
    numberDetails,
  } = props;

  const classes = useStyles({ isHebrew: isHebrew() });

  return (
    <Box
      width="100%"
      flexShrink={0}
      height="100%"
      display="flex"
      className={classes.caseStudyChild}
    >
      <Box
        id="cs-grid-item-image"
        className={classes.caseStudyChildImageContainer}
      >
        <Box
          width="100%"
          height="100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <img
            alt="case-study"
            src={imageURL}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </Box>
      </Box>
      <Box
        id="cs-grid-item-stats"
        className={classes.caseStudyChildInfoContainer}
      >
        <CaseStudyStatsBox
          icon={
            <img
              src={icon}
              alt="bullet"
              style={{ width: '32px', height: '32px' }}
            />
          }
          header={header}
          title={title}
          detail={detail}
          numberTitles={numberTitles}
          numberDetails={numberDetails}
        />
      </Box>
    </Box>
  );
};

/**
 * Master component of section
 * @returns
 */
export const CaseStudiesSection = () => {
  const classes = useStyles({ isHebrew: isHebrew() });
  const [activeStep, setActiveStep] = useState(0);
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const items = isHebrew() ? case_study_json_hebrew : case_study_json;

  return (
    <Box
      className={classes.caseStudyContainer}
      mt={4}
      mb={0}
      display="flex"
      flexDirection="column"
    >
      <HeadingText fontSize="32px" textAlign="center">
        {t('biz_lp_case_studies_title')}
      </HeadingText>
      <Box
        flexGrow={1}
        display="flex"
        flexDirection="row"
        width="100%"
        mt={5}
        overflow="hidden"
      >
        <AutoPlaySwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {items.map((item, index) => {
            return (
              <CaseStudy
                icon={item.icon}
                imageURL={item.imageURL}
                header={item.header}
                title={item.title}
                detail={item.detail}
                numberTitles={item.number_titles}
                numberDetails={item.number_details}
              />
            );
          })}
        </AutoPlaySwipeableViews>
      </Box>
      <Box
        display={{ xs: 'none', sm: 'flex' }}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        p={3}
      >
        <MobileStepper
          variant="dots"
          steps={3}
          className={classes.mobileStepper}
          classes={{
            dot: classes.mobileStepperDot,
            dotActive: classes.mobileStepperDotActive,
          }}
          position="relative"
          activeStep={activeStep}
        />
      </Box>
    </Box>
  );
};
